import React from "react"
import { OverlayTrigger, Popover } from "react-bootstrap"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faInfoCircle } from "@fortawesome/pro-regular-svg-icons"

const HelpPopover = ({ title, content }) => (
  <OverlayTrigger
    trigger={["hover", "focus"]}
    placement="right"
    overlay={
      <Popover id="help-popover" title={title}>
        <div style={{ padding: ".5rem 1rem", fontFamily: "proxima-nova, Arial, sans-serif" }}>{content}</div>
      </Popover>
    }
  >
    <span style={{ marginLeft: "8px", cursor: "pointer" }}>
      <FontAwesomeIcon icon={faInfoCircle} color="#40777C" />
    </span>
  </OverlayTrigger>
)

export default HelpPopover
